<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <div class="grid" *ngIf="carInformacionInicial">
      <div class="col-12 md:col-12 lg:col-12 text-center">
        <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
        <span>{{'LBL_CONSULTANDO' | translate }}</span>
      </div>
    </div>
    <div *ngIf="!carInformacionInicial">
      <div class="grid">
        <div class="col-12 md:col-12">
          <p-accordion id="accordion" [multiple]="false" (onOpen)="abrirAcordeon($event)">
            <p-accordionTab header="{{'EXCEPCIONESGMF.LBL_CONDIGURACIONGENERAL' | translate}}"
                            [selected]="tabSeleccionado === 'GENERAL'">
              <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fExcepcionesGmf" name="fExcepcionesGmf">
                <div class="grid form-group">
                  <div class="col-12 md:col-12 lg:col-6">
                    <div class="div-form">
                      <label>* {{ 'EXCEPCIONESGMF.LBL_CODIGO' | translate }}</label>
                      <input type="text" pInputText id="codigo"
                             name="nomCodigo"
                             autocomplete="off"
                             formControlName="codigo"
                             [maxlength]="10"
                             codigos-reactive
                      >
                      <div class="p-message p-messages-error p-corner-all" *ngIf="!excepcionGmf && submitted && f.codigo.invalid">
                        {{ 'EXCEPCIONESGMF.LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 md:col-12 lg:col-6">
                    <div class="div-form">
                      <label>* {{ 'EXCEPCIONESGMF.LBL_NOMBRE' | translate }}</label>
                      <input type="text" pInputText id="nombre"
                             name="nomNombre"
                             autocomplete="off"
                             formControlName="nombre"
                             capitalize-reactive
                             [maxlength]="50"

                      >
                      <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
                        {{ 'EXCEPCIONESGMF.LBL_NOMBRE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="grid form-group">
                  <div class="col-12 md:col-12 lg:col-12">
                    <div class="div-form">
                      <label>* {{ 'EXCEPCIONESGMF.LBL_DESCRIPCION' | translate }}</label>
                      <input type="text" pInputText id="descripcion"
                             name="nomDescripcion"
                             autocomplete="off"
                             formControlName="descripcion"
                             [maxlength]="500"

                      >
                      <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.descripcion.invalid">
                        {{ 'EXCEPCIONESGMF.LBL_DESCRIPCION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="grid form-group">
                  <div class="col-12 md:col-6 lg:col-6">
                    <div class="div-form">
                      <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="false"
                                  id="indicadorHabilitado"
                                  name="nomindicadorHabilitado"
                                  formControlName="indicadorHabilitado"></p-checkbox>
                    </div>
                  </div>
                </div>

                <div class="grid form-footer-buttons">
                  <div class="form-group col-12">
                    <div *ngIf="!guardando">
                      <a (click)="regresar( formulario.dirty )" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                      <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                              type="submit"
                              pButton></button>
                    </div>
                    <div *ngIf="guardando">
                      <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                      <span>{{'LBL_GUARDANDO' | translate }}</span>
                    </div>
                  </div>
                </div>
              </form>
            </p-accordionTab>
            <p-accordionTab  header="{{ 'EXCEPCIONESGMF.LBL_CONFIGURACIONDESTINOS' | translate }}"
                             [disabled]="!excepcionGmf"
                             [selected]="tabSeleccionado === 'CONFIGDESTINOS'">

              <app-excepciones-gmf-cofiguracion-destinos *ngIf="excepcionGmf"  [excepcionGMF]="excepcionGmf"></app-excepciones-gmf-cofiguracion-destinos>

            </p-accordionTab>
            <p-accordionTab  header="{{ 'EXCEPCIONESGMF.LBL_CONFIGURACIONDESTIONOSEXCENTOSGMF' | translate }}"
                             [disabled]="!excepcionGmf"
                             [selected]="tabSeleccionado === 'tabSeleccionado'">

              <app-excepciones-gmf-destinos-exentos *ngIf="excepcionGmf" [excepcionGMF]="excepcionGmf" ></app-excepciones-gmf-destinos-exentos>

            </p-accordionTab>
          </p-accordion>
        </div>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
